<script setup>
import { CURRICULUM_INTEGRATION_ROUTES } from "@/constants";
import { useRoute } from "vue-router";
import HeadingMenu from "./components/HeadingMenu.vue";
import SideMenu from "./components/SideMenu.vue";
import { CURRICULUM_INTEGRATION_LINKS } from "./constants.js";

const route = useRoute();
</script>
<template>
  <div class="px-2 md:px-8 py-3 bg-blue-100">
    <template v-if="route.name === CURRICULUM_INTEGRATION_ROUTES.HOME">
      <HeadingMenu heading-title="Curriculum Integration" />
      <div class="w-full mt-4 flex mb-24">
        <SideMenu :menu-items="CURRICULUM_INTEGRATION_LINKS" :route-name="route.name" />
        <router-view :key="route.fullPath" />
      </div>
    </template>
    <template v-else>
      <HeadingMenu heading-title="Curriculum Integration" />
      <router-view :key="route.fullPath" />
    </template>
  </div>
</template>
